import axios from 'axios';
import { GET_SETTINGS, SET_BACKGROUND_IMAGE } from './types';
import { API_URL } from '../../constants'

export const getSettings = (place_id = 0) => dispatch => {
    let query = "";
    if (place_id != 0) {
        query += "?place_id=" + place_id;
    }
    axios
        .get(API_URL + 'settings' + query)
        .then(res => {
            dispatch({
                type: GET_SETTINGS,
                payload: res.data
            })
        }
        ).catch(error => {
            console.log(`error`, error)
            // throw (error);
        });
}

export const setMainBackground = (p) => dispatch => {
    dispatch({
        type: SET_BACKGROUND_IMAGE,
        payload: p
    })
}